import React from 'react';
import { generatePath, useNavigate } from 'react-router';
import RoutePath from '@/Routing/RoutePath';
import useCompanyId from '@/Hooks/UseCompanyId';
import useClientIdPathParam from '@/Hooks/UseClientIdPathParam';
import { useNotificationContext } from '@/Context/NotificationContext';
import { useCreateRecruitmentContext } from '../../Create/Contexts/CreateRecruitmentContext';
import StepProps from '../StepProps';
import { ExperienceCriteriaForm, mapRhfCriteriaToExperienceCriteria } from './Components/ExperienceCriteriaForm';
import IdentifyExperienceStep from './IdentifyExperienceStep';
import IdentifyExperienceErrorDialog from './Components/IdentifiyExperienceErrorDialog';

const CreateIdentifyExperienceStep = ({ activeStep, handleBack }: StepProps): React.JSX.Element => {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const clientId = useClientIdPathParam();
    const { showFailToaster } = useNotificationContext();

    const {
        processingState,
        experienceCriteriaProcessingState,
        experienceCriteria,
        setExperienceCriteria,
        resetExperienceCriteriaProcessingState,
        createRecruitmentAsync,
    } = useCreateRecruitmentContext();

    const onSubmit = async ({ criteria }: ExperienceCriteriaForm) => {
        try {
            await createRecruitmentAsync(clientId, criteria.map(mapRhfCriteriaToExperienceCriteria));

            // navigate to client recruitment overview.
            const createRecruitmentPath = generatePath(RoutePath.AssessmentsActive, { companyId, clientId });
            navigate(createRecruitmentPath);
        } catch (error) {
            showFailToaster();
        }
    };

    return (
        <>
            <IdentifyExperienceErrorDialog />
            <IdentifyExperienceStep
                activeStep={activeStep}
                handleBack={handleBack}
                processingState={processingState}
                experienceCriteriaProcessingState={experienceCriteriaProcessingState}
                experienceCriteria={experienceCriteria}
                setExperienceCriteria={setExperienceCriteria}
                resetExperienceCriteriaProcessingState={resetExperienceCriteriaProcessingState}
                onSubmit={onSubmit}
                isEditMode={false}
            />
        </>
    );
};

export default CreateIdentifyExperienceStep;
